import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StyledButton = styled.button.attrs({ className:"button" })`
  width:${props => props.size};
  height:${props => props.size};
  margin:5px;
  padding-left: 0;
  padding-right: 0;
  overflow:hidden;
`;

function IconButton (props) {
  return (
    <StyledButton title={props.title} 
        className={props.highlighted ? "is-primary" : "is-dark"} 
        onClick={props.onClick} 
        size={props.size} 
        onMouseDown={props.onMouseDown}
        onMouseUp={props.onMouseUp}
        onTouchStart={props.onMouseDown}
        onTouchEnd={props.onMouseUp}
    >      
        <FontAwesomeIcon icon={props.icon} fixedWidth/> 
    </StyledButton>
  );
}

IconButton.defaultProps = {
  size: "45px"
};


export default IconButton;


